import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as BackArrowSvg } from "../../../../assets/backarrow.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { Formik, ErrorMessage } from "formik";
import { InputTemp, SelectTemp } from "../../../../app/common/form/Custom";
import { authSchema } from "../../../../app/validation/validationSchema";
import { ReactComponent as InfoDotGreenSvg } from "../../../../assets/infodotgreen.svg";
import { ReactComponent as InfoDotDangerSvg } from "../../../../assets/infodotdanger.svg";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Avatar1 } from "../../../../assets/avatar1.svg";
import { ReactComponent as Avatar2 } from "../../../../assets/avatar2.svg";
import { ReactComponent as Avatar3 } from "../../../../assets/avatar3.svg";
import { ReactComponent as Avatar4 } from "../../../../assets/avatar4.svg";
import { validate as uuidValidate } from "uuid";
import { useStore } from "../../../../app/stores/store";
import Loading from "../../../../app/layout/Loading";
import { observer } from "mobx-react-lite";

const ViewUser = () => {
  const navigate = useNavigate();
  const params = useParams();
  const userRoleId = params.id!;
  const [options] = useState([]);
  const { userStore } = useStore();
  const {
    guidStatus,
    currentUserRole,
    setGuidStatus,
    fetchUserRole,
  } = userStore;

  const saveForm = () => {};

  var initialValues = {
    name: currentUserRole ? currentUserRole.name : "",
    email: currentUserRole ? currentUserRole.email : "",
    lastName : currentUserRole ? currentUserRole.lastName : "",
    phoneNumber: currentUserRole ? currentUserRole.phoneNumber : "",
    roleName: currentUserRole ? currentUserRole.roleName : "",
  };
  const count = useRef(0);
  useEffect(() => {
    if (uuidValidate(userRoleId)) {
      if (guidStatus !== "loading" && count.current === 0) {
        count.current = count.current + 1;
        fetchUserRole(userRoleId).finally(() => setGuidStatus(""));
      }
    } else {
      navigate("/vendor/users");
    }
  }, []);
  return (
    <div className={styles.page}>
      {guidStatus === "loading" && <Loading />}

      <div className={styles.back}>
        <BackArrowSvg onClick={() => navigate("/vendor/users")} />
        <span>Go back</span>
      </div>
      <div className={styles.header}>
        {" "}
        <div className={styles.searchAndFilter}>
          <Button
            positive
            className={`${styles.userStatus} ${
              currentUserRole &&
              (currentUserRole.status.includes("inactive") ||
                currentUserRole.status.includes("Inactive")) &&
              styles.negative
            }`}
            // onClick={() => navigate("/vendor/new-product")}
          >
            {(currentUserRole && currentUserRole.status === "Active") ||
            (currentUserRole && currentUserRole.status === "active") || !currentUserRole? (
              <InfoDotGreenSvg />
            ) : (
              <InfoDotDangerSvg />
            )}
            <div className={styles.positive}>
              <span>
                {(currentUserRole && currentUserRole.status === "Active") ||
                (currentUserRole && currentUserRole.status === "active")
                  ? "Active"
                  : "Inactive"}
              </span>
              {/* <PlusCircle /> */}
            </div>
            {/* <GreenDropDownIcon /> */}
          </Button>
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={saveForm}
        validationSchema={authSchema.register}
      >
        {({
          dirty,
          errors,
          getFieldProps,
          handleSubmit,
          values,
          setFieldValue,
          isValid,
          isSubmitting,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className={styles.form}>
                <div className={styles.column1}>
                  <div className={styles.thumbnail}>
                    {currentUserRole &&
                      currentUserRole.roleName === "Owner" && <Avatar1 />}
                    {currentUserRole &&
                      currentUserRole.roleName === "Admin Manager" && (
                        <Avatar1 />
                      )}
                    {currentUserRole &&
                      currentUserRole.roleName === "Accountant" && <Avatar2 />}
                    {currentUserRole &&
                      currentUserRole.roleName === "Store Manager" && (
                        <Avatar3 />
                      )}
                    {currentUserRole &&
                      currentUserRole.roleName === "Store Cashier" && (
                        <Avatar4 />
                      )}
                    {!currentUserRole && <Avatar1 />}
                  </div>
                  {/* <div className={styles.edit}>
                    <div className={styles.editButton}>
                      <span>Edit</span>
                      <span>
                        <EditButtonSvg />
                      </span>
                    </div>
                  </div> */}
                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <InputTemp
                        inputType="text"
                        label={"Name"}
                        // placeholder={
                        //   product && productId !== "new"
                        //     ? product.description
                        //     : "Enter Description"
                        // }
                        disabled
                        marginRight
                        {...getFieldProps("name")}
                      />
                      <ErrorMessage
                        name={"name"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginRight}>
                    <InputTemp
                      inputType="text"
                      label={"Last Name"}
                      // placeholder={
                      //   product && productId !== "new"
                      //     ? product.description
                      //     : "Enter Description"
                      // }
                      disabled
                      marginRight
                      {...getFieldProps("lastName")}
                    />
                    <ErrorMessage
                      name={"name"}
                      render={(error) => (
                        <Label basic color="red" content={error} />
                      )}
                    />
                  </div>

                  </div>
                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <InputTemp
                        inputType="text"
                        label={"Email"}
                        // placeholder={
                        //   product && productId !== "new"
                        //     ? product.description
                        //     : "Enter Description"
                        // }
                        disabled
                        marginRight
                        {...getFieldProps("email")}
                      />
                      <ErrorMessage
                        name={"email"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <InputTemp
                        inputType="text"
                        label={"Phone Number"}
                        // placeholder={
                        //   product && productId !== "new"
                        //     ? product.description
                        //     : "Enter Description"
                        // }
                        disabled
                        marginRight
                        {...getFieldProps("phoneNumber")}
                      />
                      <ErrorMessage
                        name={"phoneNumber"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                  </div>

                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <InputTemp
                        inputType="text"
                        label={"Password"}
                        // placeholder={
                        //   product && productId !== "new"
                        //     ? product.description
                        //     : "Enter Description"
                        // }
                        disabled
                        marginRight
                        {...getFieldProps("password")}
                      />
                      <ErrorMessage
                        name={"password"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <SelectTemp
                        inputType="text"
                        label="Role"
                        placeholder={initialValues.roleName}
                        disabled
                        options={[...options]}
                        name="role"
                        // {...getFieldProps("categoryId")}
                      />
                      <ErrorMessage
                        name={"role"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                  </div>
                  {/* <div className={styles.flexStart}>
                    <div className={styles.sterlinks}>
                      Auto-Generate Password
                    </div>
                  </div> */}
                </div>
              </div>
              {/* <div className={styles.footer}>
                <div className={styles.searchAndFilter}>
                  <Button
                    positive
                    className={styles.bulkProduct}
                    // onClick={() => navigate("/vendor/new-product")}
                  >
                    <div className={styles.positive}>
                      <span>Save</span>
                    </div>
                  </Button>
                </div>
              </div> */}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default observer(ViewUser);
